




























import { Component, Prop, Vue } from 'vue-property-decorator';
import { i18n } from '@/plugins/i18n/i18n';
import router from '@/router';
import { PAGE_PATH_BY_NAME } from '@/utils/consts';

@Component
export default class ErrorMessagePageTemplate extends Vue {
  @Prop()
  private loading!: Boolean;

  @Prop()
  private altMessage!: String;

  @Prop()
  private imgName!: String;

  @Prop()
  private imgWidth!: String;

  @Prop()
  private imgHeight!: String;

  @Prop()
  private titleText!: String;

  @Prop()
  private subText!: String;

  private get imgSrc() {
    var images = require.context('../../assets/', false, /\.svg$/);
    return images('./' + this.imgName + '.svg');
  }

  private get goHomeText(): String {
    return i18n.tc('common.goHomeText');
  }

  private goHome(): void {
    router.push(PAGE_PATH_BY_NAME.portal);
  }
}
